import { axiosDS } from '@pp/axios'
import { SimpleResponse } from 'Types/simpleResponse'
import { ResponseCatalog, RequestParams } from 'Models'
import { urls } from 'Src/constants/Urls'
import { serialize } from 'object-to-formdata'
import {
	PartnerRequestInfotecs,
	FieldsRequest,
	PartnerRequestComment,
	PartnerRequestCreateModel,
	PartnerRequestInfoFile,
	PartnerRequestModel,
	PartnerRequestResume,
	PartnerRequestUpdateModel,
	PartnerRequestCreateOrderAgreementsComment,
	PartnerRequestUpdateOrderAgreementsComment,
	OrderAgreementComment,
} from 'Src/pages/partnerRequests'

export const partnerRequestApi = {
	getAll: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<PartnerRequestModel>>(
			urls.partnerRequest.index,
			{ params }
		)
		return res.data
	},
	getOne: async (id: string) => {
		const res = await axiosDS().get<PartnerRequestModel>(`${urls.partnerRequest.index}/${id}`)
		return res.data
	},
	createOne: async (data: PartnerRequestCreateModel) => {
		const res = await axiosDS().post<PartnerRequestModel>(
			urls.partnerRequest.index,
			serialize({ data }, { allowEmptyArrays: true })
		)
		return res.data
	},
	updateOne: async (id: string, data: PartnerRequestUpdateModel) => {
		const res = await axiosDS().patch<PartnerRequestModel>(`${urls.partnerRequest.index}/${id}`, {
			data,
		})
		return res.data
	},
	uploadFile: async (id: string, data: Partial<PartnerRequestComment>) => {
		const res = await axiosDS().patch<Partial<PartnerRequestComment>>(
			urls.partnerRequest.upload_file.replace(':id', id),
			serialize({ data }, { allowEmptyArrays: true })
		)
		return res.data
	},
	setStatus: async (id: string, status: string) => {
		const res = await axiosDS().patch<Partial<PartnerRequestInfoFile>>(
			urls.partnerRequest.set_status.replace(':id', id).replace(':status', status)
		)
		return res.data
	},
	agentComment: async (id: string, data: Partial<PartnerRequestComment>) => {
		const res = await axiosDS().post<Partial<PartnerRequestComment>>(
			urls.partnerRequest.agent_comment.replace(':id', id),
			serialize({ data }, { allowEmptyArrays: true })
		)
		return res.data
	},
	tmppComment: async (id: string, data: Partial<PartnerRequestComment>) => {
		const res = await axiosDS().post<Partial<PartnerRequestComment>>(
			urls.partnerRequest.tmpp_comment.replace(':id', id),
			serialize({ data }, { allowEmptyArrays: true })
		)
		return res.data
	},
	resume: async (id: string, data: PartnerRequestResume) => {
		const res = await axiosDS().patch<Partial<PartnerRequestResume>>(
			urls.partnerRequest.resume.replace(':id', id),
			serialize({ data }, { allowEmptyArrays: true })
		)
		return res.data
	},
	setStatusAgreement: async (id: string, status: string) => {
		const res = await axiosDS().patch(
			urls.partnerRequest.set_status_agremeent.replace(':id', id).replace(':status', status),
			{ status }
		)
		return res.data
	},
	uploadFileAgreement: async (id: string, data: Partial<PartnerRequestComment>) => {
		const res = await axiosDS().patch<Partial<PartnerRequestComment>>(
			urls.partnerRequest.upload_file_agreements.replace(':id', id),
			serialize({ data }, { allowEmptyArrays: true })
		)
		return res.data
	},
	getFieldsRequest: async () => {
		const res = await axiosDS().get<FieldsRequest>(urls.partnerRequest.fields_request)
		return res.data
	},
	deleteFileAgreement: async (id: string, idFile: number) => {
		const data = {
			data: {
				files_attributes: {
					id: idFile,
					_destroy: 1,
				},
			},
		}
		const res = await axiosDS().delete<SimpleResponse>(
			urls.partnerRequest.delete_file_agreements.replace(':id', id),
			{ data }
		)
		return res.data
	},
	uploadFileInfotecs: async (partner_request_id: string, infotecs_files_attributes: File[]) => {
		const data = { infotecs_files_attributes }
		const res = await axiosDS().post<PartnerRequestInfotecs>(
			urls.partnerRequest.partner_request_infotecs_files.replace(':id', partner_request_id),
			serialize({ data }, { allowEmptyArrays: true })
		)
		return res.data
	},
	deleteFileInfotecs: async (id: string) => {
		const res = await axiosDS().delete<SimpleResponse>(
			urls.partnerRequest.partner_request_delete_infotecs_files.replace(':id', id)
		)
		return res.data
	},
	setStatusFileInfotecs: async (id: string, status: string) => {
		const res = await axiosDS().patch<SimpleResponse>(
			urls.partnerRequest.partner_request_set_status_infotecs_files
				.replace(':id', id)
				.replace(':status', status)
		)
		return res.data
	},
	createOrderAgreementComment: async (data: PartnerRequestCreateOrderAgreementsComment) => {
		const res = await axiosDS().post<OrderAgreementComment>(
			urls.partnerRequest.create_order_agreement_comment,
			{ data }
		)
		return res.data
	},
	updateOrderAgreementComment: async (data: PartnerRequestUpdateOrderAgreementsComment) => {
		const { id } = data
		const res = await axiosDS().patch<OrderAgreementComment>(
			urls.partnerRequest.update_order_agreement_comment.replace(':id', id.toString()),
			{ data }
		)
		return res.data
	},
}
